import BaseAttribute from './baseAttribute';
import { Category } from '../character/allValues';

export default class DiceAttribute extends BaseAttribute {
  public category: Category = Category.Attribute;
  public numDice: number = 0;
  public numBonus: number = 0;
  public constructor(name: string) {
    super(name);
  }

  public setValue(dices: number, bonus: number) {
    this.numDice = dices;
    this.numBonus = bonus;
  }

  public getClone() {
    const clone = new DiceAttribute(this.name);
    clone.numDice = this.numDice;
    clone.numBonus = this.numBonus;
    return clone;
  }
}
